import modulos from '@/utils/modulo'

const CADASTROS_COLETIVOS = `${modulos.ARRECADACAO}/cadastrosColetivos`

const PATH = `/${process.env.PUBLIC_PATH}`

const getPathDownload = (fileKey, id) => {
  return fileKey ? `fileKey=${fileKey}` : `id=${id}`
}

export default {
  EXTERNAS: [
    'AGENDAMENTO',
    'PARAMETRIZACAO',
    'GESTAO_PRAZOS',
    'CARTORIOS',
    'CREDENCIADOS',
    'GEO_REURB',
    'PORTARIA_PROCESSOS_FISICOS',
    'RELATORIOS_TITULO_CARTORIO',
    'GESTAO_OS_REURB',
    'GESTAO_DOCUMENTOS',
    'GESTAO_OS',
    'REURB',
    'VISTORIA',
    'GESTAO_ANALISE_AUTOMATIZADA',
    'ACERVO_FUNDIARIO',
    'ANALISE_CARTOGRAFICA_PROCESSOS_FISICOS',
    'AUTOMATIZADO_GEO',
    'INVENTARIO_PATRIMONIAL',
    'MONITORAMENTO_DE_PROCESSOS',
    'MONITORAMENTO_DE_CLAUSULAS_RESOLUTIVAS',
    'TERRAS_DO_BRASIL',
    'DARSE',
    'GESTAO_DE_CREDENCIADOS'
  ],

  PUBLICO: {
    UPLOAD: process.env.PUBLIC_PATH ? `${PATH}${modulos.PUBLICO}/upload` : `${modulos.PUBLICO}/upload`
  },

  ARRECADACAO: {
    PROCESSO_COLETIVO_FIND_BY_ID: (id) => `${CADASTROS_COLETIVOS}?id=${id}`,
    SALVAR_PECA_TECNICA: (idCadastroColetivo) => `${CADASTROS_COLETIVOS}/pecaTecnica${idCadastroColetivo ? '?idCadastroColetivo=' + idCadastroColetivo : ''}`,
    SALVAR_GEORREFERENCIAMENTO: (idCadastroColetivo) => `${CADASTROS_COLETIVOS}/georreferenciamento${idCadastroColetivo ? '?idCadastroColetivo=' + idCadastroColetivo : ''}`,
    CALCULO_INTERSECT_GEO: `${modulos.ARRECADACAO}/geo/calcularGeo`,
    DOWNLOAD_DOCUMENTOS: (fileKey, id) => `${modulos.ARRECADACAO}/documentos/download?${getPathDownload(fileKey, id)}`
  }
}



// WEBPACK FOOTER //
// ./src/constants/rotas.js